var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products"},[_c('div',{staticClass:"gradient"}),_c('div',{staticClass:"container p-0"},[(_vm.screenWidth > 1024)?_c('div',{staticClass:"content"},_vm._l((_vm.productCategoreis),function(pc){return _c('div',{staticClass:"col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10"},[_c('router-link',{staticClass:"item",attrs:{"to":{
						name: 'products',
						params: {
							id: pc.productCategoryId,
							name: pc.name.replace(/ /gi, '-')
						}
					}}},[_c('div',{staticClass:"details"},[_c('label',[_vm._v(_vm._s(pc.name))])]),_c('div',{staticClass:"inner"},[_c('div',{staticClass:"img",style:({
								'background-image':
									'url(' +
									_vm.rootImagePath +
									pc.imagePath +
									')'
							})})])])],1)}),0):_vm._e(),(_vm.screenWidth <= 1024)?_c('swiper',{staticClass:"content",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.productCategoreis),function(pc,index){return _c('swiper-slide',{key:index,staticClass:"col-6 pr-2 pl-2 col-lg-3 float-right z-10"},[_c('router-link',{staticClass:"item",attrs:{"to":{
						name: 'products',
						params: {
							id: pc.productCategoryId,
							name: pc.name.replace(/ /gi, '-')
						}
					}}},[_c('div',{staticClass:"details"},[_c('label',[_vm._v(_vm._s(pc.name))])]),_c('div',{staticClass:"inner"},[_c('div',{staticClass:"img",style:({
								'background-image':
									'url(' +
									_vm.rootImagePath +
									pc.imagePath +
									')'
							})})])])],1)}),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"}),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"})],2):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }